// removed by extract-text-webpack-plugin
module.exports = {"playerSummary":"src-components----player-summary-module---playerSummary---2dwBA","statRow":"src-components----player-summary-module---statRow---CwoN7","statLabel":"src-components----player-summary-module---statLabel---QWvOM","stat":"src-components----player-summary-module---stat---11pU7","statList":"src-components----player-summary-module---statList---BgWkb","specialMoveList":"src-components----player-summary-module---specialMoveList---2Ud3F","skill":"src-components----player-summary-module---skill---2TS3d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/player-summary.module.css
// module id = 297
// module chunks = 35783957827783